import React from 'react'

class Footer extends React.Component {
  render () {
    return (
      <footer >© Michael Anokye - View <a href="https://github.com/michaelanokyej" >projects</a></footer>
    );
  }
}

export default Footer;